var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exclamation_svg__clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "exclamation_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 23
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.354.798l10.469 19.615a1.509 1.509 0 01-1.333 2.22H1.508c-.53 0-1.021-.28-1.294-.733a1.511 1.511 0 01-.035-1.488L10.694.797a1.507 1.507 0 112.66.001zm-2.84 17.308a1.51 1.51 0 103.02 0 1.51 1.51 0 00-3.02 0zm1.91-3.047a1.511 1.511 0 01-1.908-1.455V7.568a1.51 1.51 0 013.018 0v6.036a1.51 1.51 0 01-1.11 1.455z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#exclamation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exclamation_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDApIj48bWFzayBpZD0iYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIzIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjM1NC43OThsMTAuNDY5IDE5LjYxNWExLjUwOSAxLjUwOSAwIDAgMS0xLjMzMyAyLjIySDEuNTA4Yy0uNTMgMC0xLjAyMS0uMjgtMS4yOTQtLjczM2ExLjUxMSAxLjUxMSAwIDAgMS0uMDM1LTEuNDg4TDEwLjY5NC43OTdhMS41MDcgMS41MDcgMCAxIDEgMi42Ni4wMDF6bS0yLjg0IDE3LjMwOGExLjUxIDEuNTEgMCAxIDAgMy4wMiAwIDEuNTEgMS41MSAwIDAgMC0zLjAyIDB6bTEuOTEtMy4wNDdhMS41MTEgMS41MTEgMCAwIDEtMS45MDgtMS40NTVWNy41NjhhMS41MSAxLjUxIDAgMCAxIDMuMDE4IDB2Ni4wMzZhMS41MSAxLjUxIDAgMCAxLTEuMTEgMS40NTV6IiBmaWxsPSIjZmZmIi8+PC9tYXNrPjxnIG1hc2s9InVybCgjYSkiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjR2MjRIMHoiLz48L2c+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjR2MjRIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";
export { SvgExclamation as ReactComponent };